<!-- Navigation Bar -->
<nav class="navbar navbar-expand-lg" role="navigation">
  <img src="assets/images/icons/running-shoe.png" class="img-responsive" id="logo" aria-hidden="true"
    alt="running shoe logo">
  <a class="navbar-brand" routerLink="/home">Online Fit Expert</a>
  <button role="button" class="navbar-toggler" (click)="isNavbarCollapsed = !isNavbarCollapsed" data-toggle="collapse"
    data-target="collapsibleNavbar" type="button" data-toggle="collapse"
    aria-label="Click to open navigation menu on mobile devices" data-target="#collapsibleNavbar">
    <span class="navbar-toggler-icon"></span>
    <p hidden="true">Menu toggler button</p>
  </button>
  <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/home" itabindex="0" aria-label="click to go to home page">Home</a>
      </li>
      <li class="nav-item">
        <a htabindex="0" routerLink="/quiz" aria-label="click to go to the quiz page">Quiz</a>
      </li>
      <!-- <li class="nav-item">
          <a tabindex="0" routerLink="/quiz" fragment="speed" aria-label="click to go to the speed section of the quiz page">Speed</a>
        </li>
        <li class="nav-item">
            <a tabindex="0" routerLink="/quiz" fragment="cushion" aria-label="click to go to the cushion section of the quiz page">Cushion</a>
          </li>
        <li class="nav-item">
            <a tabindex="0" routerLink="/quiz" fragment="stability" aria-label="click to go to the stability section of the quiz page">Stability</a>
          </li> -->
      <li class="nav-item">
        <a tabindex="0" routerLink="/search" aria-label="click to go to search for shoes">Search</a>
      </li>
      <li class="nav-item">
        <a tabindex="0" routerLink="/search" fragment="favorites"
          aria-label="click to go to see your favorited shoes">Favorites</a>
      </li>
      <li class="nav-item">
        <a tabindex="0" routerLink="/choose-your-workout"
          aria-label="click to go to find a workout plan tailor made for your goals">Find your Workout Plan</a>
      </li>
      <li class="nav-item">
        <a tabindex="0" routerLink="/your-workout-plan" aria-label="click to go to see your premade workout plans">My
          Workout Plan</a>
      </li>
      <li class="nav-item">
        <a tabindex="0" routerLink="/your-running-workout-plan" aria-label="click to go to see your premade running workout plans">My
          Running Plan</a>
      </li>
      <li class="nav-item">
        <a tabindex="0" routerLink="/track-my-workout" aria-label="click to go track and create your workouts">Track My
          Workout</a>
      </li>
    </ul>
  </div>
</nav>